import { render, staticRenderFns } from "./FooterDark.vue?vue&type=template&id=57283bd5&scoped=true&"
import script from "./FooterDark.vue?vue&type=script&lang=js&"
export * from "./FooterDark.vue?vue&type=script&lang=js&"
import style0 from "./FooterDark.vue?vue&type=style&index=0&id=57283bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57283bd5",
  null
  
)

export default component.exports